export var AccountRelationshipType;
(function (AccountRelationshipType) {
    AccountRelationshipType[AccountRelationshipType["OWNER"] = 1] = "OWNER";
    AccountRelationshipType[AccountRelationshipType["OPERATOR"] = 2] = "OPERATOR";
    AccountRelationshipType[AccountRelationshipType["SERVICER"] = 3] = "SERVICER";
    AccountRelationshipType[AccountRelationshipType["HOLDER"] = 4] = "HOLDER";
})(AccountRelationshipType || (AccountRelationshipType = {}));
